import React from 'react';

const BuildInfo = () => {
  const commitHash = import.meta.env.REACT_APP_COMMIT_HASH || 'dev';
  const shortHash = commitHash.substring(0, 7);
  const repoUrl = 'https://github.com/zerodaysec/skynet-paper-boy-svc';

  const styles = {
    container: {
      fontSize: '11px',
      color: '#888',
      fontFamily: 'monospace',
      marginTop: '8px',
    },
    link: {
      color: '#aaa',
      textDecoration: 'none',
    }
  };

  return (
    <div style={styles.container}>
      <a
        href={`${repoUrl}/commit/${commitHash}`}
        target="_blank"
        rel="noopener noreferrer"
        style={styles.link}
      >
        v{shortHash}
      </a>
    </div>
  );
};

export default BuildInfo;
